import { useSupabase } from '@/hooks/useSupabase'
import { supabase } from '@/lib/supabase'
import type { Emergence } from '@/types'

export function useEmergences() {
  return useSupabase<Emergence[]>(async () => {
    const { data, error } = await supabase
      .from('emergences')
      .select('*')
      .in('status', ['new', 'explored'])
      .order('created_at', { ascending: false })

    if (error) throw error
    return data || []
  })
}

export function useNewEmergences() {
  return useSupabase<Emergence[]>(async () => {
    const { data, error } = await supabase
      .from('emergences')
      .select('*')
      .eq('status', 'new')
      .order('created_at', { ascending: false })
      .limit(10)

    if (error) throw error
    return data || []
  })
}

export function useUpdateEmergence() {
  const updateStatus = async (id: string, status: 'new' | 'explored' | 'accepted' | 'discarded') => {
    const { data, error } = await supabase
      .from('emergences')
      .update({ status })
      .eq('id', id)
      .select()
      .single()

    if (error) throw error
    return data
  }

  const createEmergence = async (emergence: Omit<Emergence, 'id' | 'created_at'>) => {
    const { data, error } = await supabase
      .from('emergences')
      .insert({
        ...emergence,
        created_at: new Date().toISOString()
      })
      .select()
      .single()

    if (error) throw error
    return data
  }

  return { updateStatus, createEmergence }
}